import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { Avatar, DisplayName, HorizontalStack, IconValueBlock, ShowIf, Status } from '@ztechapps/webui.util'
import { PhoneNumberDisplay } from '@ztechapps/webui.input'
import { getCompanyOrProfileName } from '@ztechapps/common.utils'
import type { Company, UserProfile, UserStatusEnum } from '@ztechapps/common.contract'

export type VendorWidgetProps = {
  profile?: UserProfile
  status?: UserStatusEnum
  linkTo?: string
  company?: Company
  phone?: string
  showAvatar?: boolean
}
export const VendorWidget = ({ profile, status, linkTo, company, phone, showAvatar = true }: VendorWidgetProps) => {
  return (
    <HorizontalStack gap={2} className="align-items-start">
      <ShowIf condition={showAvatar}>
        <div>
          <Avatar name={getCompanyOrProfileName({ company, profile })} />
        </div>
      </ShowIf>
      <div>
        <div className="fw-bold">
          {status && <Status value={status} />}
          <DisplayName company={company} profile={profile} linkTo={linkTo} />
        </div>

        <ShowIf condition={!isEmpty(profile?.name)}>
          <div className="small">
            <IconValueBlock icon="address-card" value={profile?.name} />
          </div>
        </ShowIf>
        <ShowIf condition={!!profile?.email}>
          <div className="small">
            <IconValueBlock icon="envelope">
              <a href={`mailto:${profile?.email}`}>{profile?.email}</a>
            </IconValueBlock>
          </div>
        </ShowIf>
        <ShowIf condition={!!phone}>
          <div className="small">
            <IconValueBlock icon="phone">
              <a href={`tel:${phone}`}>
                <PhoneNumberDisplay value={phone} />
              </a>
            </IconValueBlock>
          </div>
        </ShowIf>
      </div>
    </HorizontalStack>
  )
}
